import {action, computed, IObservableArray, makeObservable, observable, runInAction} from "mobx";
import {common} from "@mui/material/colors";

export class UserConfigStore {

    constructor() {
        makeObservable(this);
    }
    @observable userLogin:string = "";
    @observable userPassword:string = "";
    @observable canSaveTranslation: boolean = false;
    @observable openAlert: boolean = false

    mainLanguagesChosenIdSet: IObservableArray<string> = observable.array([]);
    targetLanguagesChosenIdSet: IObservableArray<string> = observable.array([]);


    @action
    clear() {
        //render
        this.userLogin = ""
        this.userPassword = ""
        this.canSaveTranslation = false;
        this.mainLanguagesChosenIdSet.clear();
        this.targetLanguagesChosenIdSet.clear();

        //render
    }

    @action
    handleOpenAlert () {
        this.openAlert = !this.openAlert
    }

    @action
    handleCloseAlert ()  {
        this.openAlert = false
    };

    @action
    handleChange() {
        this.canSaveTranslation = !this.canSaveTranslation
    }

    @computed
    get isDisabled() {
        return  this.mainLanguagesChosenIdSet.length > 0 && this.targetLanguagesChosenIdSet.length > 0
    }

}

